import React from 'react'
import axios from 'axios'
import Uploader from './../components/uploader'
import PerformanceDates from './../components/performance_dates'
import ShowCredits from './../components/show_credits'
import ShowStaff from './../components/show_staff'
import MediaLibrary from './../components/media_library'
import VideoLibrary from './../components/video_library'

const Item = ({item, remove, update, submit, handleImageUploadComplete, handleMediaUpdate, handleVideoUpdate}) => {
	return (
		<form data-id={item.id} onChange={ (e) => {update(e.target.closest('form'))} } onSubmit={submit}>
			<div>
				<input type="text" defaultValue={item.title ? decodeURIComponent(item.title) : ''} placeholder="Show Title" className="title" />
				<textarea defaultValue={item.description ? decodeURIComponent(item.description) : ''} placeholder="Description" className="description"></textarea>

				<label><input type="checkbox" checked={!!item.isFeatured} className="isFeatured" onChange={()=>{}} /> Is Featured</label>
				<label><input type="checkbox" checked={!!item.isHero} className="isHero" onChange={()=>{}} /> Is Hero</label>
				<label><input type="checkbox" checked={!!item.ticketsOnSale} className="ticketsOnSale" onChange={()=>{}} /> Tickets on Sale</label>

				<PerformanceDates dates={item.performance_dates} />

				<ShowStaff show_staff={item.show_staff} />

				<textarea defaultValue={item.directors_notes ? decodeURIComponent(item.directors_notes) : ''} placeholder="Director's Notes" className="directors_notes"></textarea>
				<textarea defaultValue={item.producers_notes ? decodeURIComponent(item.producers_notes) : ''} placeholder="Producer's Notes" className="producers_notes"></textarea>

				<ShowCredits show_credits={item.show_credits} />
			</div>

				<h3>Banner</h3>
				{
					item.banner ?
						<img src={item.banner} alt={item.name} className="banner" /> :
						null
				}
				<Uploader
					className="banner_drop"
					uploadComplete={ (imageURL) => handleImageUploadComplete(imageURL, item.id, 'banner') }
					label="Drop an image (or click) to update banner"
				/>

				<h3>Thumb</h3>
				{
					item.thumb ?
						<img src={item.thumb} alt={item.name} className="thumb_preview" /> :
						null
				}
				<Uploader
					className="thumb_drop"
					uploadComplete={ (imageURL) => handleImageUploadComplete(imageURL, item.id, 'thumb') }
					label="Drop an image (or click) to update thumb"
				/>

				<h3>Icon</h3>
				{
					item.icon ?
						<img src={item.icon} alt={item.name} className="icon_preview" /> :
						null
				}
				<Uploader
					className="icon_drop"
					uploadComplete={ (imageURL) => handleImageUploadComplete(imageURL, item.id, 'icon') }
					label="Drop an image (or click) to update icon"
				/>

				<MediaLibrary media_library={item.media_library} handleMediaUpdate={ () => {handleMediaUpdate(item.id)} } />
				<VideoLibrary video_library={item.video_library} handleVideoUpdate={ () => {handleVideoUpdate(item.id)} } />

				{/*<button type="delete" onClick={ () => {remove(item.id)}}>Delete {decodeURIComponent(item.title)}</button>*/}
		</form>
	)
}

const List = ({items, remove, update, submit, handleImageUploadComplete, handleMediaUpdate, handleVideoUpdate}) => {
	return (
		<div className="items_container">
			{items.map( item => {
				return (<Item
					item={item}
					key={item.id}
					remove={remove}
					update={update}
					submit={submit}
					handleImageUploadComplete={handleImageUploadComplete}
					// handleVideoDataComplete={handleVideoDataComplete}
					handleMediaUpdate={handleMediaUpdate}
					handleVideoUpdate={handleVideoUpdate} /> )
			})}
		</div>
	)
}

class Show extends React.Component {
	constructor(props){
		super(props)

		this.state = {
			items: [],
			readyToSave: false,
			changesSaved: false,
			message: ''
		}
	}

	componentDidMount(){
		this.fetchData()
	}

	fetchData(){
		axios.get('https://dhsetheatre-api.madebypeppernet.com//api-admin.php', {
			params: {
				filename: 'shows',
				preview: 'true',
			}
		}).then( response => {
			// Need to store all of the shows in the state (so we can save all of them easily).
			this.setState({
				items: response.data.items
			})
		})
	}

	handleImageUploadComplete(imageURL, id, type){
		// Need to store the imageURL to the form.
		var items = this.state.items.map( item => {
			if(item.id === id){
				item[type] = imageURL
			}
			return item
		})

		this.setState({
			items: items,
			readyToSave: true,
			message:''
		})
	}

	// handleItemRemove(id){
	// 	// This * might * be a bit too dangerous...

	// 	// Filter the list by the item selected to remove.
	// 	const items = this.state.items.filter( item => item.id != id )

	// 	// Save the updated array to state.
	// 	this.setState({
	// 		items: items,
	// 		readyToSave: true
	// 	})
	// }

	handleItemUpdate(form){
		// Generate a new list updating the selected item.
		var items = this.state.items.map( item => {
			// Set up some global booleans. (For example, only one show can be the hero.)
			let isHero = form.querySelector('.isHero').checked

			// eslint-disable-next-line
			if(item.id == form.getAttribute('data-id')){
				// Compile the performance dates.
				let performance_dates = [...form.querySelectorAll('.performance_dates .date_container')].map( (performance_date) => {
					return {
						id: performance_date.getAttribute('data-id'),
						date: performance_date.querySelector('.date').value,
						time: performance_date.querySelector('.time').value
					}
				})

				// Compile the show credits.
				let show_credits = [...form.querySelectorAll('.show_credits .credits_container')].map( (show_credit) => {
					return {
						id: show_credit.getAttribute('data-id'),
						title: show_credit.querySelector('.title').value,
						name: show_credit.querySelector('.name').value
					}
				})

				// Compile the show staff.
				let show_staff = [...form.querySelectorAll('.show_staff .staff_container')].map( (show_credit) => {
					return {
						id: show_credit.getAttribute('data-id'),
						title: show_credit.querySelector('.title').value,
						name: show_credit.querySelector('.name').value
					}
				})

				// Compile the media.
				let media_library = [...form.querySelectorAll('.media_library .media_container')].map( (media) => {
					return {
						id: media.getAttribute('data-id'),
						imageURL: media.querySelector('img').getAttribute('data-src')
					}
				})

				// Compile the videos.
				let video_library = [...form.querySelectorAll('.media_library .video_container')].map( (video) => {
					return {
						id: video.getAttribute('data-id'),
						videoId: encodeURIComponent(video.querySelector('.videoId').value),
						imageURL: encodeURIComponent(video.querySelector('img') ? video.querySelector('img').getAttribute('data-src') : ''),
						title: encodeURIComponent(video.querySelector('.video_title').innerText)
					}
				})

				return {...item,
					id: form.getAttribute('data-id'),
					title: encodeURIComponent(form.querySelector('.title').value),
					description: encodeURIComponent(form.querySelector('.description').value),
					directors_notes: encodeURIComponent(form.querySelector('.directors_notes').value),
					producers_notes: encodeURIComponent(form.querySelector('.producers_notes').value),
					isFeatured: form.querySelector('.isFeatured').checked,
					isHero: form.querySelector('.isHero').checked,
					ticketsOnSale: form.querySelector('.ticketsOnSale').checked,
					performance_dates: performance_dates,
					show_credits: show_credits,
					show_staff: show_staff,
					media_library: media_library,
					video_library: video_library
				}
			} else {
				if(isHero){
					item.isHero = false
				}
				return item
			}
		})

		this.setState({
			items: items,
			readyToSave: true,
			message: ''
		})
	}

	handleSaveChanges(){
		// Create the data to store.
		var data = {
			items: this.state.items,
		}

		// Save the items to the API.
		axios({
			method: 'POST',
			url: 'https://dhsetheatre-api.madebypeppernet.com//api-admin.php',
			headers: { 'Content-type': 'application/x-www-form-urlencoded' },
			data: {
				filename: 'shows',
				content: JSON.stringify(data)
			}
		}).then( (response) => {
			this.setState({
				readyToSave: false,
				changedSaved: true,
				message: 'Preview Saved'
			})
		})
	}

	handleMediaUpdate(formId){
		// Get the form.
		this.handleItemUpdate(document.querySelector('form[data-id="' + formId + '"]'))
	}

	handleSubmit(e){
		// Kill default functionality.
		e.preventDefault()
		return false
	}

	// handleVideoDataComplete(){
	// 	this.setState({
	// 		items: items,
	// 		readyToSave: true,
	// 		message:''
	// 	})
	// }

	handleVideoUpdate(formId){
		// Get the form.
		this.handleItemUpdate(document.querySelector('form[data-id="' + formId + '"]'))
	}

	render() {
		return (
			<section className="container edit">
				<h2>Show Edit</h2>
				{ this.state.readyToSave ?
						<button className="save button" onClick={this.handleSaveChanges.bind(this)}>Save Preview</button> :
						null
				}
				{
					this.state.message.length ?
						<p className="message">{this.state.message}</p> :
						null
				}
				<List
					// eslint-disable-next-line
					items={this.state.items.filter( item => item.id == this.props.id ) }
					// remove={this.handleItemRemove.bind(this)}
					update={this.handleItemUpdate.bind(this)}
					submit={this.handleSubmit.bind(this)}
					handleImageUploadComplete={this.handleImageUploadComplete.bind(this)}
					// handleVideoDataComplete={this.handleVideoDataComplete.bind(this)}
					handleMediaUpdate={this.handleMediaUpdate.bind(this)}
					handleVideoUpdate={this.handleVideoUpdate.bind(this)}
				/>
			</section>
		)
	}
}

export default Show



// WEBPACK FOOTER //
// ./src/components/show.js